import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.secondary.main} !important`,
    borderBottom: `1px solid ${palette.background.divider}`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.citrintestosterone-container': {
    '& .normal-text': {
      fontWeight: 300,
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        background: palette.background.header,
        '& .hero-header-subtitle, .hero-header-title': {
          color: palette.text.primary,
        },
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      marginTop: 72,
      background: palette.background.tertiary,
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          fontSize: 42,
          fontWeight: 700,
          lineHeight: '55px',
          letterSpacing: '-1.52px',
          maxWidth: 600,

          '@media(min-width: 678px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: 80,
            lineHeight: '80px',
            letterSpacing: '0.8px',
            fontWeight: '600',

          },
          '@media (min-width: 768px) and (max-width: 1023px)': {
            maxWidth: 'none',
            textAlign: 'left',
          },
          '@media (min-width: 1024px) and (max-width: 1366)': {
            color: 'red',
          },
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          maxWidth: 500,
          lineHeight: '30px',
          maxWidth: 600,
          '@media(min-width: 767px)': {
            fontSize: 18,
          },
          '@media (min-width: 768px) and (max-width: 1024px)': {
            maxWidth: 'none',
            textAlign: 'left',
          },
        },
      },
      '& .section-header__title-wrapper': {
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .image-wrapper': {
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
        '@media(max-width: 900px)': {
          display: 'none',
        },
      },
      '@media(min-width: 900px)': {
        maxHeight: '740px',
      },
      '@media(max-width: 900px)': {
        '& .hero-title, .hero-subtitle': {
          textAlign: 'center',
        },
        '& .section-header__cta-wrapper': {
          '& .section-header__cta-container': {
            '& .section-header__cta-item-wrapper': {
              width: '100%',
              '@media (min-width: 768px) and (max-width: 1024px)': {
                display: 'flex',
              },
            },
          },
        },
      },
    },

    '& .definition-Wrapper': {
      background: palette.background.howItWorks,
      '& .definition-variant-2': {
        '& .section-header': {
          '@media(min-width: 900px)': {
            paddingBottom: 48,
          },
          '& .section-header__title': {
            fontSize: 42,
            '@media(min-width: 900px)': {
              fontSize: 80,
            },
          },
        },
        '& .definition-service-title': {
          '@media(max-width: 900px)': {
            fontSize: 24,
          },
        },
        '& .section-header__subtitle': {
          '@media(min-width: 900px)': {
            fontSize: 20,
          },
        },
        '& .benefits-wrapper': {
          '& .definition-service-title': {
            '@media(min-width: 900px)': {
              fontSize: 24,
            },
          },
          '& .definition-service-description': {
            '@media(min-width: 900px)': {
              fontSize: 16,
              maxWidth: 420,
              fontWeight: 400,
            },
          }
        },
        '@media(min-width: 900px)': {
          padding: '80px !important',
        },
      },
      '& .section-alternate__content': {
        '@media(min-width: 900px)': {
          padding: '0px 16px',
        },
      }
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.main,
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.main,
      },
      '& .subscription-section': {
        minHeight: 'auto',
        '& .section-header__subtitle-wrapper': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .desc-box': {
        display: 'none',
      },
      '& .rating': {
        fontSize: 18,
        paddingBottom: 12,
        color: palette.text.primary,
      },
      '& .description-section': {
        backgroundColor: palette.divider,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
          },
          '& .customGetStarted': {
            width: '96%',
          },
          '& .customCardContent': {
            background: palette.background.card,
            padding: '32px 24px',
            '& .price-item': {
              marginBottom: 0,
            },
          },
        },
      },
      '@media(min-width: 900px)': {
        '& .section-header__title': {
          fontSize: 56,
        },
        '& .section-header__subtitle': {
          maxWidth: 650,
          fontSize: 20,
        },
        '& .left-section': {
          paddingLeft: 48,
        },
      },
      '@media(max-width: 900px)': {
        '& .section-header__title': {
          fontSize: 42,
        },
        '& .description-section': {
          marginTop: 12,
        },
        '& .review-box': {
          marginBottom: 32,
        },
        '& .section-header__subtitle': {
          maxWidth: 590,
          fontSize: 20,
        },
      },
      '& .react-multi-carousel-dot button': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        background: palette.text.highlight,
        border: 'none',
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .section-header__title': {
        fontWeight: 'normal',
      },
      '& .how-cover-image': {
        height: 450,
      },
      '& .step-counter': {
        backgroundColor: palette.background.main,
        color: palette.text.highlight,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
      '@media(max-width: 900px)': {
        '& .how-cover-image': {
          height: '100%',
        },
      },
      '@media(min-width: 900px)': {
        '& .howitworks-title': {
          marginBottom: 32,
        },
        '& .howitworks-wrapper': {
          paddingLeft: 40,
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title': {
        fontWeight: 'normal',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        background: palette.background.secondaryLight,
      },
      '& .hero-static-section': {
        '@media(min-width:900px)': {
          padding: 0,
        },
      },
      '& .section-alternate__content': {
        '@media(min-width:1200px)': {
          padding: '96px 54px'
        },
      },
      '& .primary-static-button': {
        background: palette.text.highlight,
        border: `1px solid ${palette.text.primary}`,
        color: palette.text.primary,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.primary.main}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.divider,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
      '& .hero-static-bg': {
        background: `${palette.background.footer} !important`,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'auto',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '84px',
        maxWidth: '84px',
      },
      '& .provider-contact-link': {
        fontSize: 20,
        fontWeight: 'bold',
      },
      '& .provider-contact-details': {
        color: palette.text.secondary,
        fontWeight: 400,
      },
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.primary.main,
      },
      '& .stepperIconActive': {
        color: `${palette.primary.main} !important`,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .stepperIconRoot': {
        color: 'transparent',
        borderColor: palette.primary.main,
        '& .stepperIconText': {
          fill: palette.primary.main,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.primary.main,
      },
    },

    /* Freebie Style */
    '& .freebie-section': {
      background: palette.background.tertiaryLight,
      '& .freebie-container': {
        flexDirection: 'row-reverse',
        background: palette.tertiaryLight,
      },
      '& .freebie-wrapper-right': {
        '@media(min-width:900px)': {
          position: 'relative',
          top: 32,
        },
        '@media(max-width:900px)': {
          paddingBottom: 12,
        },
      },
      '& .freebie-cover-image': {
        '@media(min-width: 900px)': {
          height: 600,
        },
      },
      '& .freebie-title': {
        '@media(min-width: 900px)': {
          fontSize: '64px !important',
          lineSpacing: '-1.6em',
          lineHeight: '80px',
          marginBottom: 32,
        },
      },
      '& .freebie-subtitle': {
        '@media(min-width: 900px)': {
          fontSize: '18px !important',
          fontWeight: 'lighter',
        },
      },
      '& .link-button': {
        background: palette.text.highlight,
        color: palette.text.primary,
        border: `1px solid ${palette.text.primary}`,
      },
    },
    /* Footer style */
    '& .footer-wrapper': {
      background: palette.background.footerSecondary,
      borderTop: `1px solid ${palette.divider}`,
      color: palette.text.highlight,
      '& .footer-link, .copyrights-footer-link': {
        color: palette.text.highlight,
      },
      '& .copyrights-footer': {
        borderTop: `1px solid ${palette.divider}`,
      },
      '& .MuiGrid-item': {
        '@media(min-width: 900px)': {
          padding: '16px 8px'
        },
        '@media(min-width: 1400px)': {
          padding: '16px 28px'
        },
      }
    },
  },
};
